import { render } from "./NoResultsBox.vue?vue&type=template&id=144f2b1b"
import script from "./NoResultsBox.vue?vue&type=script&lang=js"
export * from "./NoResultsBox.vue?vue&type=script&lang=js"

import "./NoResultsBox.vue?vue&type=style&index=0&id=144f2b1b&lang=scss"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__